export default __webpack_public_path__ + "static/media/moodle.0f9dd4b1.png";